<template>
    <div class="main">
        <c-panel title="MENSAGENS" titleIcon="fas fa-envelope">

            <el-row :gutter="10" class="u-mb-15">
                <el-col :xs="24" :sm="14">
                    <el-radio-group v-model="aba" size="small" @change="load">
                        <el-radio-button label="entrada">
                            Caixa de Entrada <el-badge v-if="naoLidas > 0" :value="naoLidas" type="danger" />
                        </el-radio-button>
                        <el-radio-button label="saida">Enviadas</el-radio-button>
                    </el-radio-group>
                </el-col>
                <el-col :xs="24" :sm="10" class="u-text-right">
                    <el-button type="primary" icon="el-icon-edit-outline" @click="abrirNova">NOVA MENSAGEM</el-button>
                </el-col>
            </el-row>

            <table class="table table-striped">
                <thead>
                    <tr v-if="aba === 'entrada'">
                        <th style="width:30px;"></th>
                        <th>De</th>
                        <th>Assunto</th>
                        <th style="width:140px;">Recebida em</th>
                        <th style="width:200px;" class="u-text-center">Ações</th>
                    </tr>
                    <tr v-else>
                        <th>Para</th>
                        <th>Assunto</th>
                        <th style="width:140px;">Enviada em</th>
                        <th style="width:200px;" class="u-text-center">Ações</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="m in items" :key="m.id" :style="aba==='entrada' && !m.lida_at ? 'font-weight:bold;' : ''">
                        <td v-if="aba==='entrada'">
                            <i v-if="!m.lida_at" class="el-icon-message-solid" style="color:#409eff;"></i>
                            <i v-else class="el-icon-message" style="color:#909399;"></i>
                        </td>
                        <td v-if="aba==='entrada'">{{ m.remetente ? m.remetente.name : '?' }}</td>
                        <td v-else>{{ destinatario(m) }}</td>
                        <td>
                            <a href="javascript:void(0)" @click="abrirLeitura(m)">{{ m.assunto }}</a>
                        </td>
                        <td>{{ m.created_at | formatarDt }}</td>
                        <td class="u-text-center">
                            <el-button size="mini" plain icon="el-icon-view" @click="abrirLeitura(m)">ABRIR</el-button>
                            <el-button size="mini" plain icon="el-icon-folder" @click="arquivar(m.id)">ARQUIVAR</el-button>
                        </td>
                    </tr>
                    <tr v-if="!items.length">
                        <td :colspan="aba==='entrada' ? 5 : 4" class="u-text-center" style="padding:20px; color:#909399;">Nenhuma mensagem.</td>
                    </tr>
                </tbody>
            </table>

            <!-- Leitura -->
            <el-dialog title="" :visible.sync="modalLeituraVisivel" width="700px" @open="onAbrirLeitura">
                <div v-if="msgAtual">
                    <h2 style="margin-top:0;">{{ msgAtual.assunto }}</h2>
                    <p style="color:#909399;">
                        <strong>De:</strong> {{ msgAtual.remetente ? msgAtual.remetente.name : '?' }}
                        | <strong>Para:</strong> {{ destinatario(msgAtual) }}
                        | <strong>{{ msgAtual.created_at | formatarDt }}</strong>
                    </p>
                    <hr/>
                    <div style="white-space:pre-wrap; padding:10pt 0;">{{ msgAtual.corpo }}</div>
                    <hr/>
                    <div v-if="msgAtual.respostas && msgAtual.respostas.length">
                        <h3 style="color:#606266;">Respostas</h3>
                        <div v-for="r in msgAtual.respostas" :key="r.id" style="margin-bottom:10pt; padding:8pt; background:#f4f4f5;">
                            <p style="margin:0; color:#909399;">{{ r.remetente ? r.remetente.name : '?' }} — {{ r.created_at | formatarDt }}</p>
                            <div style="white-space:pre-wrap;">{{ r.corpo }}</div>
                        </div>
                    </div>
                </div>
                <span slot="footer">
                    <el-button @click="modalLeituraVisivel = false">FECHAR</el-button>
                    <el-button v-if="msgAtual && aba === 'entrada'" type="primary" @click="abrirResposta">RESPONDER</el-button>
                </span>
            </el-dialog>

            <!-- Nova / resposta -->
            <el-dialog :title="form.parent_id ? 'Responder' : 'Nova mensagem'" :visible.sync="modalNovaVisivel" width="640px">
                <el-form label-position="top" :model="form" ref="formRef">
                    <el-row :gutter="10" class="u-mt-20">
                        <el-col :xs="24">
                            <el-form-item label="Destinatário">
                                <el-select v-model="form.destinatario_user_id"
                                    filterable remote reserve-keyword :remote-method="buscarUsuario" :loading="loadUsuario"
                                    placeholder="Digite o nome do usuário..." style="width:100%;" :disabled="!!form.parent_id" clearable>
                                    <el-option v-for="u in usuariosBusca" :key="u.id" :label="u.usuario ? `${u.name} (${u.usuario})` : u.name" :value="u.id"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-form-item label="Assunto" prop="assunto" :rules="[$requiredBlur]">
                        <el-input v-model="form.assunto" maxlength="255" show-word-limit></el-input>
                    </el-form-item>
                    <el-form-item label="Mensagem" prop="corpo" :rules="[$requiredBlur]">
                        <el-input type="textarea" v-model="form.corpo" :rows="6"></el-input>
                    </el-form-item>
                </el-form>
                <span slot="footer">
                    <el-button @click="modalNovaVisivel = false">CANCELAR</el-button>
                    <el-button type="primary" @click="enviar">ENVIAR</el-button>
                </span>
            </el-dialog>
        </c-panel>
    </div>
</template>

<script>
import moment from 'moment'
export default {
    filters: { formatarDt (v) { return v ? moment(v).format('DD/MM/YYYY HH:mm') : '' } },
    data () {
        return {
            aba: 'entrada',
            items: [], naoLidas: 0,
            modalLeituraVisivel: false, msgAtual: null,
            modalNovaVisivel: false,
            form: this.formVazio(),
            usuariosBusca: [], loadUsuario: false
        }
    },
    mounted () {
        this.load()
        this.contarNaoLidas()
        // abertura via link direto (ex.: notificação -> /admin/mensagem/:id)
        if (this.$route.params.id) this.abrirLeitura({ id: this.$route.params.id })
    },
    methods: {
        baseUrl () { return this.$store.state.config.baseUrlApi },

        formVazio () {
            return {
                destinatario_tipo: 'user',
                destinatario_user_id: null, destinatario_aluno_id: null, destinatario_servidor_id: null,
                instituicao_id: null, parent_id: null,
                assunto: '', corpo: ''
            }
        },

        destinatario (m) {
            if (m.destinatario_user)     return m.destinatario_user.name + ' (usuário)'
            if (m.destinatario_aluno)    return m.destinatario_aluno.nome + ' (aluno)'
            if (m.destinatario_servidor) return m.destinatario_servidor.nome + ' (servidor)'
            return '—'
        },

        load () {
            const endpoint = this.aba === 'entrada' ? 'caixaEntrada' : 'caixaSaida'
            this.$axios.post(`${this.baseUrl()}/api/mensagem-interna/${endpoint}`, {}, this.$store.getters.getHeaderAuth)
                .then(r => { this.items = (r.data && r.data.data) ? r.data.data : (r.data || []) })
                .catch(e => this.$store.commit('throwException', e))
        },
        contarNaoLidas () {
            this.$axios.get(`${this.baseUrl()}/api/mensagem-interna/naoLidas`, this.$store.getters.getHeaderAuth)
                .then(r => { this.naoLidas = (r.data && r.data.total) || 0 })
                .catch(() => { this.naoLidas = 0 })
        },

        abrirLeitura (m) {
            this.$axios.get(`${this.baseUrl()}/api/mensagem-interna/getById/${m.id}`, this.$store.getters.getHeaderAuth).then(r => {
                this.msgAtual = r.data || null
                this.modalLeituraVisivel = true
            })
        },
        onAbrirLeitura () {
            if (this.msgAtual && this.aba === 'entrada' && !this.msgAtual.lida_at) {
                this.$axios.post(`${this.baseUrl()}/api/mensagem-interna/marcarLida/${this.msgAtual.id}`, {}, this.$store.getters.getHeaderAuth)
                    .then(() => { this.msgAtual.lida_at = new Date().toISOString(); this.contarNaoLidas(); this.load() })
            }
        },
        arquivar (id) {
            this.$axios.post(`${this.baseUrl()}/api/mensagem-interna/arquivar/${id}`, {}, this.$store.getters.getHeaderAuth)
                .then(() => { this.load(); this.contarNaoLidas() })
        },

        abrirNova () {
            this.form = this.formVazio()
            this.usuariosBusca = []
            this.modalNovaVisivel = true
        },
        abrirResposta () {
            this.form = this.formVazio()
            this.form.parent_id = this.msgAtual.id
            this.form.assunto = 'Re: ' + this.msgAtual.assunto
            // Responder vai para o remetente original
            this.form.destinatario_user_id = this.msgAtual.remetente_user_id
            // pré-popula o select para exibir o nome do destinatário da resposta
            const rem = this.msgAtual.remetente
            this.usuariosBusca = rem ? [{ id: rem.id, name: rem.name, usuario: rem.usuario || '' }] : []
            this.modalLeituraVisivel = false
            this.modalNovaVisivel = true
        },
        buscarUsuario (q) {
            if (!q || q.length < 2) { this.usuariosBusca = []; return }
            this.loadUsuario = true
            this.$axios.post(`${this.baseUrl()}/api/mensagem-interna/buscarUsuarios`, { query: q }, this.$store.getters.getHeaderAuth)
                .then(r => { this.usuariosBusca = r.data || []; this.loadUsuario = false })
                .catch(() => { this.loadUsuario = false })
        },
        enviar () {
            this.$refs.formRef.validate(valid => {
                if (!valid) { window.eventBus.$emit('alert', { msg: 'Preencha os campos obrigatórios.', type: 'warning' }); return }
                const inst = this.$store.state.config.instituicao
                this.form.instituicao_id = inst && inst.id ? inst.id : null

                this.$axios.post(`${this.baseUrl()}/api/mensagem-interna/enviar`, this.form, this.$store.getters.getHeaderAuth).then(r => {
                    if (r.data && r.data.erro) {
                        window.eventBus.$emit('alert', { msg: typeof r.data.erro === 'string' ? r.data.erro : r.data.erro.text, type: 'warning' })
                        return
                    }
                    window.eventBus.$emit('alert', { msg: 'Mensagem enviada.', type: 'success' })
                    this.modalNovaVisivel = false
                    this.aba = 'saida'
                    this.load()
                })
            })
        }
    },
    watch: {
        // outra notificação clicada enquanto já estamos na tela (mesmo componente reaproveitado)
        '$route.params.id' (id) {
            if (id) this.abrirLeitura({ id })
        }
    }
}
</script>
